// import apiRequest from "@/services/apiRequest";

export default {
  namespaced: true,
  state: {
    showMessageModal: false
  },
  getters: {},
  mutations: {
    setShowMessageModal(state, showPopup) {
      state.showMessageModal = showPopup;
      window.scrollTo(0, 0);
    }
  }
  // actions: {
  //     async logout() {
  //         let createLead = await apiRequest.post('https://trader.alvexo.com/web-api/v3/client/logout');
  //         console.log(createLead);
  //     },
  // }
};
